import { service } from '../../../../helpers/http' 

export const ActionGetAmbiences = ({ dispatch }, payload) => { 
    return service({
        module: 'domainAmbience',
        action: 'getAmbiences',
        payload: payload
    })
}

export const ActionPostAmbiences = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbience',
        action: 'postAmbiences',
        payload: payload
    })
    
}

export const ActionPutAmbiences = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbience',
        action: 'putAmbiences',
        payload: payload
    })
    
}

export const ActionDeleteAmbiences = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbience',
        action: 'deleteAmbiences',
        payload: payload
    })
    
}
